<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cYaps5/tc-custom/9781667444659.jpg?1682168952506" alt="This image is the cover for the book Estou farta! Mamãe vai ao Caribe"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Estou farta! Mamãe vai ao Caribe
      </h1>
      <p class="bookDescription body article font2">
        <p>A mamãe está farta!<br/> É isso aí!<br/> Ela passa sua vida lavando, cozinhando, passando a ferro e cuidando de todos.<br/> Ela não aguenta mais, ela precisa tanto de férias, então ela vai ao Caribe!<br/> Matias, de oito anos, seu irmão Antônio e seu pai ficarão por conta própria durante uma semana.<br/> Descubra suas aventuras!<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        A.P. Hernández, Angela Gaia Vampre
      </h2>
      
      <p class="authorDescription body article">Antonio Pérez Hernández é professor do Ensino Fundamental (especialista em Educação Musical, Audição e Linguagem e Pedagogia Terapêutica), pedagogo, Mestre em Pesquisa e Inovação em Educação e Doutor, menção cum laude, pela sua Tese de Doutorado Avaliação da competência em comunicação linguística por meio de histórias no Ensino Fundamental.<br/> Ele foi premiado com um segundo prêmio no Prêmio de Criação Literária Nemira e um resultado finalista no Concurso Internacional de Romance de Fantasia e Terror de Dagón.<br/> Publicou mais de quarenta livros, traduzidos em sete idiomas: grego, alemão, português, italiano, inglês, francês e holandês.<br/> Atualmente combina seu trabalho docente com a escrita.<br/></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Babelcube Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b10f3dda